import { createFileRoute } from '@tanstack/react-router'

const SeedWeightsPage = () => {
  return (
    <div className="mt-6 flex-col pb-6 sm:w-full">
      <h4 className="mb-2 text-xl font-bold text-gray-800">Seed Weights</h4>

      <p className="mb-2">
        The only compulsory fields are '1000 seed weight', 'source reference'
        and 'type of material weighed'.
      </p>

      <p className="mb-2">
        It is important to realise when interpreting the seed weight module that
        errors may be contained in some values. For example, seeds may or may
        not have minor covering structures, or some debris included, and some
        might have even been weighed in the fruits if the seeds are particularly
        difficult to extract. Another potential error to be considered is
        whether the researcher is referring to fresh or dry seeds, if it is not
        clearly stated.
      </p>
    </div>
  )
}

export const Route = createFileRoute('/definitions/seed-weights')({
  component: SeedWeightsPage,
})
